import React from 'react'
import { Stack } from '@/components/shared/atoms/layout/Stack'
import { SectionLabel } from '@/components/frontend/atoms/typography/SectionLabel'
import { Heading } from '@/components/frontend/atoms/typography/Heading'
import { Text } from '@/components/frontend/atoms/typography/Text'

interface SectionIntroProps {
  label: string
  title: string
  subtitle?: string
  align?: 'start' | 'center'
  as?: 'h1' | 'h2'
}

export const SectionIntro: React.FC<SectionIntroProps> = ({
  label, title, subtitle, align = 'start', as = 'h2',
}) => (
  <Stack gap="4" align={align}>
    <SectionLabel>{label}</SectionLabel>
    <Heading level={as === 'h1' ? '1' : '2'} as={as}>{title}</Heading>
    {subtitle && <Text size="lg" tone="secondary">{subtitle}</Text>}
  </Stack>
)
